<div class="container">
  <div class="label" *ngIf="label || state.errorText">
    {{ label }}

    <div class="caption" *ngIf="isShowError() && state.errorText">
      {{ state.errorText }}
    </div>
  </div>

  <div class="select" [class.error]="!state.isFocused && state.errorText && state.isTouched" [ngClass]="size">
    <nz-select
      class="select-control"
      style="width: 100%;"
      [ngModel]="value"
      (ngModelChange)="onValueChangeSelect($event)"
      [nzPlaceHolder]="placeholder"
      [nzDisabled]="disabled"
      (nzOpenChange)="onOpenChange($event)"
    >
      <nz-option
        *ngFor="let opt of options"
        [nzValue]="opt.value"
        [nzLabel]="opt.label | translate"
      ></nz-option>
    </nz-select>
  </div>
</div>
